import { getNextAvailableRoute } from '@dvp/helpers/Route'

import useStatus from '@shared/hooks/useStatus'

import { ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'

// HOOKS
const { isOnboardingSecured, routeStates } = useStatus()

export default [
  {
    beforeEnter: function (to, _from, next) {
      const { hasProducts, isBasketValidForAllProducts } = routeStates.value

      // Check products -> if screen gets entered directly, then it should reroute to basket
      if (!isBasketValidForAllProducts || !hasProducts) {
        next({
          name: ROUTE_NAME.BASKET,
          params: {
            lang: to.params.lang,
          },
        })
      } else if (isOnboardingSecured.value) {
        const nextRoute = getNextAvailableRoute(to)
        next(Object.assign({}, nextRoute.path, { replace: true, params: { lang: to.params.lang } }))
      } else {
        next()
      }
    },
    component: () => import('@shared/modules/Dvp/screens/ScreenOnboarding'),
    path: 'onboarding',
    meta: {
      index: ROUTE_INDEX.ONBOARDING,
      navigation: false,
    },
    name: ROUTE_NAME.ONBOARDING,
  },
]
